export enum OrganizationStatus {
  Terminated = 'TERMINATED',
  Active = 'ACTIVE',
  Created = 'CREATED'
}
